<template>
  <div class="carrousel">
    <slider ref="slider"
      class="slider"
      :options="options"
      @slide="onSlide">
      <slideritem
        v-for="(partner, index) in partners"
        :key="index"
        :style="{ ..._self.style }">
        <div class="slider-item-wrapper" @click="changeSlide(index + 1)">
          <partners-card
            :title="partner.title"
            :color="partner.color"
            :link="partner.link"
            :size='size'
            :border="border"
            :assetName="partner.assetName"
            :borderRadius="borderRadius"
            class="slider__item"
          />
        </div>
      </slideritem>
    </slider>
    <div class="s-pagination">
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="s-page"
        :class="_self.slide === index + 1 ? 'active' : ''"
        @click="changeSlide(index + 1)"
      />
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider';
import PartnersCard from '../../../components/common/PartnersCard.vue';

export default {
  components: {
    PartnersCard,
    slider,
    slideritem,
  },
  props: {
    partners: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      default: 96,
    },
    border: {
      type: Number,
      default: 2,
    },
    gap: {
      type: Number,
      default: 15,
    },
    borderRadius: {
      type: Number,
      default: 16,
    },
  },
  data: () => ({
    options: {
      currentPage: 0,
    },
    slide: 1,
  }),
  methods: {
    changeSlide(item) {
      this.slide = item;
      this.currentTime = 0;
      this.updateSlideSlider();
    },
    updateSlideSlider() {
      if (!this.$refs.slider) {
        return;
      }

      this.$refs.slider.$el.querySelector(`.slider-pagination-bullet:nth-child(${this.slide})`).click();
    },
    onSlide(data) {
      this.changeSlide(data.currentPage + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.carrousel {
  .slider {
    padding-bottom: 12px;
  }

  .item {
    width: 100%;
    height: 100%;
    //max-height: 266px;
    //margin-bottom: 26px;
    border-radius: 8px;
    border: none;
    color: var(--gray-700);
    background-color: var(--white);
    box-shadow: 0px 4px 8px 2px rgba(0, 0, 0, 0.15);

    cursor: pointer;

    position: relative;
    overflow: hidden;

    .progress {
      position: absolute;
      top: 0px;

      width: 0%;
      height: 4px;
      background-color: var(--primary);

      transition: none;
    }

    .body {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      //height: 60px;
      margin-top: 20px;
      margin-bottom: 16px;

      padding-left: 16px;
      padding-right: 16px;

      .title, .text {
        width: 100%;
        text-wrap: normal;
        //margin-left: 16px;
        text-align: left;
        white-space: pre-wrap;
      }
      .title {
        font-size: 18px;
        line-height: 24px;
      }

      .text {
        margin-top: 14px;
      }
    }
  }

  .slider-container {
    overflow-x: auto;

    &::-webkit-scrollbar {
      margin-left: 10px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: var(--gray-200);
    }
  }

  .s-pagination {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
  .slider-wrapper {
    align-items: stretch !important;
    align-content: stretch !important;
  }

  .slider-item-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    overflow: auto;
    margin-right: 8px;
  }

  .slider-item {
    display: inline-flex;
    flex: 1 1 auto;
  }

  ::v-deep .slider-pagination {
    display: none;
  }
</style>
